import BackImage from "../images/Back-Image.jpg";
import Indiaflag from "../images/india.svg";
import OmanFlag from "../images/OmanFlag.svg";
import Qatarflag from "../images/Qatar.svg";
import Europflag from "../images/europ.svg";
import Chainaflag from "../images/chaina.svg";
import AustraliaFlag from "../images/australia.svg";
import Usaflag from "../images/Usa.svg";
import Saudiflag from "../images/saudi-arabia.svg"
import logo1 from "../images/logo-1.svg";
import logo2 from "../images/logo-2.svg";
import logo3 from "../images/logo-3.svg";
import logo4 from "../images/logo-4.svg";
import logo5 from "../images/logo-5.svg";
import logo6 from "../images/logo-6.svg";
import logo7 from "../images/logo-7.svg";
import logo8 from "../images/logo-8.svg";
import logo9 from "../images/logo-9.svg";
import logo2_bg from "../images/logo-2-bg.svg";
import logo3_bg from "../images/logo-3-bg.svg";
import logo4_bg from "../images/logo-4-bg.svg";
import logo5_bg from "../images/logo-5-bg.svg";
import logo6_bg from "../images/logo-6-bg.svg";
import footerLogo from "../images/Zecca_Footer_Logo.svg";
import logo from "../images/logo.png"
import productModal from "../images/product-modal.jpg"
import zeccalogo from "../images/Zecca.svg"
import BackImage1 from "../images/Back-Image1.png"
import mobilelogo from "../images/mobile-logo.svg"
import aboutlogo from "../images/about-card-logo.svg"
import mobileback from "../images/Back-mobile.png"
import p12 from "../images/p12.png"
import p9 from "../images/p9.png"
import p2 from "../images/p2.png"
import p3 from "../images/p3.png"
import p14 from "../images/p14.png"
import p13 from "../images/p13.png"
import p7 from "../images/p7.png"
import p10 from "../images/p10.png"
import p4 from "../images/p4.png"
import p16 from "../images/p16.png"
import p8 from "../images/p8.png"
import p5 from "../images/p5.png"
import p11 from "../images/p11.png"
import p6 from "../images/p6.png"
import p15 from "../images/p15.png"
import p1 from "../images/p1.png"
import heroImage from "../images/hero-back.png"
import homemain from "../images/home-main.png"
import home_main_mobile from "../images/home-mobile-main.png"
import zeccanavlogo from "../images/Zecca-navlogo.svg"
import about_logo from "../images/aboutlogo.svg"
import usa_about from "../images/usa-about.png"
import uae_about from "../images/uae-about.png"
import image_slide_1 from "../images/image-slide-1.png"
import image_slide_2 from "../images/image-slide-2.png"
import image_slide_3 from "../images/image-slide-3.png"
import image_slide_4 from "../images/image-slide-4.png"
import image_mslide_1 from "../images/image-mslide-1.png"
import image_mslide_2 from "../images/image-mslide-2.png"
import image_mslide_3 from "../images/image-mslide-3.png"
import image_mslide_4 from "../images/image-mslide-4.png"
const images = {
  p1,
  p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12,p13,p14,p15,p16
}
export {
  BackImage,
  Indiaflag,
  OmanFlag,
  Qatarflag,
  Europflag,
  Chainaflag,
  AustraliaFlag,
  Usaflag,
  Saudiflag,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo2_bg,
  logo3_bg,
  logo4_bg,
  logo5_bg,
  logo6_bg,
  footerLogo,
  logo,
  productModal,
  zeccalogo,
  BackImage1,
  mobilelogo,
  aboutlogo,
  mobileback,
  heroImage,
  homemain,
  zeccanavlogo,
  about_logo,
  home_main_mobile,
  uae_about,
  usa_about,
  image_slide_1,
  image_slide_4,
  image_slide_3,
  image_slide_2,
  image_mslide_1,
  image_mslide_2,
  image_mslide_3,
  image_mslide_4
};
export default images;